export const jsonToString = ({ name, config }: { name: any; config: any }) =>
  JSON.stringify({ name, config }, null, 2);
